import { getMemberRewards } from './get-member-rewards';
export const getMemberRewardById = (rewardId) => {
    const rewards = getMemberRewards();
    return rewards === null || rewards === void 0 ? void 0 : rewards.find(reward => reward.rewardId === rewardId);
};
//# sourceMappingURL=get-member-reward-by-id.js.map